import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { clone, path } from 'ramda'

const state = {
  authCredentials: null,
  gainAccessLink: ''
}

const getters = {
  // isGoogleAuthinticated would change in future
  // we will take credentials by id
  // for details ask BE Olexiy (olexiy.kulchitskiy@adraba.io)
  isGoogleAuthinticated: state => !!path(['authCredentials', 'credentials', '0', 'refreshToken'], state),
  getGoogleAccessLink: state => state.gainAccessLink
}

const actions = {
  // GOOGLE AUTHORIZATION
  async fetchGoogleAuthLink ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data: { link } } = await this.$axios.get(api.google.fetchGoogleAuthLink())
      commit(types.SET_GOOGLE_ACCESS_LINK, link)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to fetch Google auth link')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchGoogleAuthCredentials ({ commit, getters }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.google.fetchGoogleAuthCredentials())
      commit(types.SET_GOOGLE_CREDENTIALS, data)

      if (!getters.isGoogleAuthinticated) {
        this.dispatch('fetchGoogleAuthLink')
      }
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to fetch Google auth credentials')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async googleAuthorize ({ commit }, authCode) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.google.authorize(authCode))
      this.dispatch('fetchGoogleAuthCredentials')
    } catch (err) {
      if (path(['response', 'data', 'Code'], err) !== 'google.auth-0007') {
        commit(types.CREATE_ERROR_MESSAGE, 'Failed to authorize in Google Account')
        throw err
      }
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },

  // GOOGLE ANALYTICS
  async updateGoogleAnalyticsSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.generalSettings.updateSetting(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were successfully updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to update settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },

  // GOOGLE SHEETS SETTINGS
  async updateGoogleSheetSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.google.updateSettings(), {
        messageTypeSettingsDictionary: payload
      })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were successfully updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to update settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_GOOGLE_CREDENTIALS] (state, credentials) {
    state.authCredentials = clone(credentials)
  },
  [types.SET_GOOGLE_ACCESS_LINK] (state, link) {
    state.gainAccessLink = link
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/google.js